<template>
  <div id="navbar">
    <!-- Header -->
    <nav class="navbar navbar-expand-lg navbar-light">
      <a
        class="navbar-brand"
        href="#"
      ><img
        src="/images/logo.png"
        alt="logo zonasea"
        class="logo-zonasea"
      ></a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerDemo02"
        aria-controls="navbarTogglerDemo02"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon" />
      </button>

      <div
        id="navbarTogglerDemo02"
        class="collapse navbar-collapse"
      >
        <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
          <li
            v-for="(link, index) in links"
            :key="index"
            class="nav-item p-2"
          >
            <a
              v-smooth-scroll
              class="nav-link"
              :href="link.href"
            >{{ link.text }}</a>
          </li>
          
          <li class="nav-item p-2">
            <button
              class="btn btn-outline-primary pl-4 pr-4"
              data-toggle="modal"
              data-target="#modalLogin"
            >
              Login
            </button>
          </li>
          <li class="nav-item p-2">
            <button
              class="btn btn-primary"
              data-toggle="modal"
              data-target="#modalRegister"
            >
              Register
            </button>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  name: "Navbar",
  data () {
    return {
      links: [
        {
          text: 'Benefit',
          href: '#benefit'
        },
        {
          text: 'Cara Kerja',
          href: '#carakerja'
        },
        {
          text: 'Tentang Kami',
          href: '#about'
        }
      ]
    }
  },
}
</script>
<style lang="scss">
</style>
